var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advert"},[_c('Link',{attrs:{"to":_vm.advData.url || ''}},[_c('img',{attrs:{"src":_vm.advData.adImage,"alt":_vm.advData.title}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }